import React, { useCallback } from 'react';
import range from 'lodash/range';
import Placeholder from '../Placeholder';
import SidebarGrid from '../SidebarGrid';
import TitlePlaceholder from '../TitlePlaceholder';
import s from './LoaderBlock.scss';
const items = range(0, 9);
const LoaderBlock = ({ index  })=>{
    const renderItem = useCallback(({ item , width , height , className: itemClassName  })=>/*#__PURE__*/ React.createElement(Placeholder, {
            key: item,
            width: width,
            height: height,
            className: itemClassName
        }), []);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['block-header']
    }, /*#__PURE__*/ React.createElement(TitlePlaceholder, {
        splitIndex: index
    })), /*#__PURE__*/ React.createElement(SidebarGrid, {
        items: items,
        maxRows: 3,
        renderItem: renderItem
    }));
};
LoaderBlock.displayName = 'LoaderBlock';
export default LoaderBlock;
